import { WebshopProductModel } from "models/WebShop";
import { useEffect, useMemo, useState } from "react";
import { webShopService } from "services/Services";
import LoadingScreen from "./LoadingScreen";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";
import ProductPromo from "./ProductPromo";
import { useOrders } from "context/useOrderData";
import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { Seo } from "./Seo";


type ProductListProps = {
    displayExtra?: boolean
}

const ProductList = ({ displayExtra }: ProductListProps) => {
    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();
    const { saleStatusByCompany } = useOrders();
    const [products, setProducts] = useState<WebshopProductModel[] | undefined>([]);
    const [loadingProducts, setLoadingProducts] = useState<boolean>(true);

    const [overrides, setOverrides] = useState<Record<string, boolean>>({});

    useEffect(() => {
        async function getData() {
            const productsList = await webShopService.getProducts();
            if (productsList !== undefined) {
                setProducts(productsList);
            }

            const configs = await webShopService.getProductConfigurations(params.id ?? "");

            if (configs !== undefined) {

                setOverrides({
                    [UrlPath.Account.ProductConfig.Logo]: configs.logo !== null,
                    [UrlPath.Account.ProductConfig.BulletPoints]: configs.bulletPoints !== null,
                    [UrlPath.Account.ProductConfig.InfoText]: configs.infoText !== null,
                    [UrlPath.Account.ProductConfig.ExtraLinks]: configs.extraLinks !== null,
                });

            }

            setLoadingProducts(false);
        }

        getData();
    }, []);

    const getOverride = (key: string): boolean => {
        return overrides[key] ?? false;
    };


    if (companySaleCheck[companyId] === undefined || !companySaleCheck[companyId].allowed)
        return null;

    const activeProductIdSet = new Set(
        saleStatusByCompany[companyId].orderStatuses.flatMap(status =>
            status.activeProducts.map(product => product.id)
        )
    );

    const filteredProducts = params.product
        ? products?.filter(product => product.path !== params.product)
        : products;


    return (
        <>
            {loadingProducts ? (
                displayExtra ? <LoadingScreen /> : null
            )
                : (
                    filteredProducts !== undefined && filteredProducts.length > 0 ? (
                        <div className="card mt-3">
                            <div className="card-body">
                                {displayExtra ? <> <Seo title={"Kjøp utvidet informasjon"}></Seo> <h1 className="h3">Kjøp utvidet informasjon</h1> </>: <h2 className="h5">Kjøp utvidet informasjon</h2> }
                                <ul className="cc-shop-items list-unstyled">
                                    {filteredProducts.map(product => {
                                        const isActive = activeProductIdSet.has(product.webShopProductId);

                                        return (
                                            <ProductPromo
                                                key={product.path}
                                                name={product.name}
                                                path={product.path}
                                                companyId={params.id ?? ""}
                                                description={product.description}
                                                linkText={product.linkText}
                                                overrideLink={getOverride(product.path)}
                                                isActive={isActive}
                                            />
                                        );
                                    })}

                                </ul>
                                {displayExtra && <p className="mt-4 mb-0">
                                    <Link to={UrlPath.MyAccount.Home} className="btn btn-outline-primary"><i className="bi bi-arrow-left"></i> Tilbake</Link>
                                </p>}
                            </div>
                        </div>
                    ) : null
                )}
        </>
    );

};

export default ProductList;
